export default {
  state: () => ({
    activeSurvey: null,
    myNutritionData: {},
    onboard: false,
    surveyStep: 1
  })
}



// WEBPACK FOOTER //
// ./src/app/store/surveys/config.js